import { PickKeyOfObject, PickKeyOfString, PickObjectRecursive } from "@/common/declare";
import { observable } from "vue/types/umd";

const properNoun = {

}

const dlc = {
    ACCOUNTING: "會計",
    ACTION: "操作",
    Add: "添加",
    AddAgent: "新增代理商",
    AddArticle: "文章资讯",
    AddBanner: "添加橫幅",
    AdditionalContact: "額外聯繫方式",
    ADDITIONALCONTACT: "額外聯繫方式",
    ADDITIONALDESCRIPTION: "額外描述",
    address: "地址",
    administrators: "管理员",
    ADULT: "成人",
    Agencyrate: "代理費率",
    AgentInformation: "代理信息",
    AIRCRAFT: "飛機",
    AIRLINES: "航空公司",
    AIRPORTTAX: "機場稅",
    all: "全部",
    ALLOW_BAG_SEAT: "行李/座位",
    amount: "金額",
    Amount: "金額",
    ANCILARY: "輔助服務",
    ANCILLARIES: "輔助服務",
    APPROVEDBY: "批准者",
    AreYouSure: "你確定嗎？",
    Areyousureseat: "你確定要預訂座位嗎？",
    ARRIVAL: "到達",
    AVAILABILITY: "可用性",
    Back: "返回",
    balance: "餘額",
    Balance: "餘額",
    banner: "橫幅",
    BasicFare: "基本票價",
    BIRTHDATE: "出生日期",
    BOOK: "預訂",
    BOOKCODE: "預訂代碼",
    BOOKDATE: "預訂日期",
    BOOKEDBY: "預訂人",
    BOOKINFO: "預訂信息",
    CABIN: "艙位",
    CALLER: "呼叫者",
    cancel: "啟用文章",
    CancelBook: "取消預訂",
    CANCELBOOKING: "取消預訂",
    CancelledBasicFare: "取消的基本票價",
    CancelledSurchargeFee: "取消的附加費",
    CancelledTerminalFee: "取消的終端費",
    cancelorder: "已取消",
    CheckPrice: "檢查價格",
    checkURLformat: "充值記錄",
    CHILD: "兒童",
    CLASS: "艙位",
    close: "啟用",
    Commissionrebate: "傭金回扣",
    Commissionsharing: "其他退款",
    Companydetails: "公司詳情",
    confirm: "確認",
    Confirmrefund: "確認退款",
    CONTACT: "聯繫方式",
    ContactInfo: "聯繫信息",
    Contactphonenumber: "聯繫電話",
    Uploadimages: "上傳",
    corporateName: "公司名稱",
    CREATEBY: "創建者",
    CreateNewBooking: "創建新預訂",
    Createrefundform: "創建退款表",
    Creationtime: "創建時間",
    Currency: "貨幣",
    DATE: "日期",
    Deactivate: "停用",
    Deductionamount: "金額扣除",
    delete: "刪除",
    Deleteorder: "刪除訂單",
    DEP_ARV: "出發/到達",
    Departure: "出發",
    DEPARTURE: "出發",
    DEPARTUREDATE: "出發日期",
    DepartureRouteInfo: "出發路線信息",
    Description: "描述",
    DESCRIPTION: "描述",
    DESTINATION: "目的地",
    DESTNATION: "目的地",
    detail: "詳情",
    determine: "确定",
    Disablearticles: "启用",
    Disabled: "禁用",
    DURATION: "時長",
    edit: "編輯",
    email: "郵箱",
    Email: "郵箱",
    Enable: "Enable",
    Enablearticles: "禁用文章",
    EndofTransaction: "交易結束",
    ETicket: "電子票",
    expenditure: "支出",
    FARE: "票價",
    fast: "快速",
    FEES: "費用",
    file: "文件",
    FIRSTNAME: "名",
    FLIGHT: "航班",
    FLIGHTDATE: "航班日期",
    FLIGHTNUMBER: "航班號",
    global: {
        input_add: "添加",
        input_cancel: "取消",
        input_confirm: "確認",
        input_copy: "複製",
        input_disable: "禁用",
        input_edit: "編輯",
        input_enable: "啟用",
        input_export: "導出",
        input_filter: "篩選",
        input_search: "搜索",
        input_sync: "刷新",
        label_nav_create: "創建",
        label_nav_edit: "編輯",
        label_no: "否",
        label_warn: "提示",
        label_yes: "是",
        lang_cn: "中文",
        lang_eng: "英文",
        msg_copy_success: "複製成功",
        msg_post_success: "發布成功",
        ph_all: "全部",
        ph_end: "結束日期",
        ph_range: "至",
        ph_start: "開始日期",
        require: "請輸入",
        require_phoneNumber: "請輸入正確格式的電話號碼",
        fn_localPrice: '{localPrice,0}',
        fn_tYMD: '{timeYMD,0,1,2}',
        fn_tHM: '{timeHM,0,1}',
        fn_tDate: '{formatDate,0}',
    },
    GROUPNAME: "團隊名稱",
    HandmadePlus: "傭金共享",
    home: {
        input_account_hint: "庫存SKU/總SKU",
        input_login: "登錄",
        input_password_hint: "庫存SKU/總SKU",
        input_remember: "記住密碼",
        link_forget: "忘記密碼？",
        link_regist_1: "沒有賬號？",
        link_regist_2: "註冊",
        require_account: "請輸入賬號",
        require_password: "請輸入密碼",
        welcome_1: "歡迎使用Fanslink CDMS",
        welcome_2: ""
    },
    hotspot: "热点",
    income: "收入",
    INFANT: "嬰兒",
    INPUTBY: "輸入者",
    INPUTDATE: "輸入日期",
    INSURANCE: "燃油附加費",
    issuancefailed: "出票失敗",
    issuedsuccessfully: "成功出票",
    Keberangkatan: "出發",
    LASTNAME: "姓",
    Loginaccount: "登錄賬號",
    macroMutexSelector: "macromutex選擇",
    Manualdeduction: "更新代理",
    Mobile: "手機號碼",
    MOBILE: "電話號碼",
    MODIFICATION: "改签",
    ModifyRefundLimit: "修改退款限額",
    MyBookings: "我的預訂",
    name: "名称",
    Name: "姓名",
    nationality: "國籍",
    NATIONALITY: "國籍",
    NewBooking: "新預訂",
    NEWREFUNDLIMIT: "新的退款限額",
    No: "否",
    NO: "序号",
    normal: "正常",
    notIncomplete: "檢查URL格式",
    NUMERICCODE: "數字代碼",
    objective: "目的",
    OddNumbers: "訂單編號",
    OFFICE: "辦公室",
    open: "關閉",
    operation: "操作",
    Ordercompleted: "訂單完成",
    Orderrefund: "支付訂單",
    ORIGIN: "出發地",
    ORNUMBER: "OR號碼",
    OTHERFEE: "其他費用",
    Otherrefunds: "訂單退款",
    OUTSTANDING: "金额",
    pagination: {
        label_total: "每頁總計(0)"
    },
    PASSENGER: "乘客",
    PassengerInfo: "乘客信息",
    PASSENGERNAME: "乘客姓名",
    PASSENGERS: "乘客",
    PASSPORT: "護照",
    PASSPORTEXPDATE: "護照到期日期",
    PASSPORTEXPIRYDATE: "護照到期日期",
    PASSPORTNUMBER: "護照號碼",
    password: "密碼",
    PAX: "乘客",
    PaxInfo: "乘客信息",
    PAXTYPE: "乘客類型",
    Payment: "支付",
    PAYMENT: "支付",
    PaymentHistory: "支付歷史",
    PaymentOrder: "手動扣款",
    Pendingrefund: "待退款",
    Pendingreview: "待審核",
    phone: "電話號碼",
    picture: "图片",
    Pleaseamount: "退款金額",
    PleaseConfirm: "確認",
    Pleaseenter: "輸入",
    pleasefeeslist: "確認費用清單",
    pleasereason: "確認原因",
    Pleaseupload: "提示",
    PREPAIDBAGGAGE: "預付行李",
    PreviousBalance: "之前的餘額",
    PRINTBOOKING: "下载預訂",
    Printltinerary: "打印所有行程",
    PRINTPNR: "打印PNR",
    PrintSMTicket: "打印SM票",
    PRMOMCODE: "優惠碼",
    prompt: "提示",
    PULANGPERGI: "往返",
    query: "查詢",
    reason: "原因",
    REASON: "原因",
    ReBookFee: "重新預訂費",
    RebookInfo: "重新預訂信息",
    Recharge: "手動添加",
    Rechargedetails: "充值详情",
    Rechargerecords: "充值记录",
    Refund: "退款",
    REFUND: "退款",
    RefundableAmount: "可退款金額",
    REFUNDABLES: "可退款",
    refundamount: "退款金額",
    Refundcompleted: "退款完成",
    Refundfailed: "退款失敗",
    RefundFee: "退款費",
    RefundLimit: "退款限額",
    Refusalrefund: "不允許退款",
    refuse: "拒絕",
    region: "地區",
    Remarks: "备注",
    ReprintReceipt: "重新打印收據",
    RESERVESEAT: "預訂座位",
    Restrictsales: "限制銷售",
    Returndate: "返回日期",
    role: "角色",
    ROUTE: "路線",
    RouteInfo: "路線信息",
    SATUARAH: "單程",
    SEAT: "座位",
    Seatfailed: "座位預訂失敗",
    SeatReserved: "已預訂座位",
    seatsuccessful: "座位預訂成功",
    Selectendtime: "結束時間",
    Selectstarttime: "開始時間",
    SERVICEDAY: "服務天",
    ShowRemarksInfo: "顯示備註信息",
    sort: "排序",
    state: "狀態",
    STATUS: "狀態",
    SURCHARGE: "附加費",
    SurchargeFee: "附加費",
    surplus: "充值",
    TCP: "TCP（完整團隊）",
    TerminalFee: "終端費",
    TERMINALFEE: "終端費",
    TICKETING: "訂票",
    ticketNo: "票號",
    TICKETNUMBER: "票號",
    time: "時間",
    TIMELIMIT: "時間限制",
    title: "标题",
    TITLE: "称谓",
    TKTNUMBER: "票號",
    tocontinue: "確定",
    TopUp: "充值",
    TOTAL: "總計",
    Totalcost: "總成本",
    TotalPreviousPayment: "之前的總支付",
    TOTALPRICE: "總價",
    TRAMSIT: "中轉",
    TRANSACTIONDATE: "交易日期",
    TRANSIT: "中轉",
    Turnoffhotspot: "關閉熱點",
    Turnonhotspot: "關閉熱點",
    type: "類型",
    uac: {
        enum_invalid: "無效",
        enum_valid: "有效",
        input_cancle: "取消",
        input_confirm: "確認",
        input_create: "添加部門",
        input_del: "刪除",
        label_add: "添加",
        label_add_part: "添加部門",
        label_delete_depart: "刪除部門",
        label_delete_role: "刪除角色",
        label_delete_user: "刪除用戶",
        label_department: "所屬部門",
        label_edit: "編輯",
        label_edit_part: "編輯部門",
        label_email: "員工郵箱",
        label_employeeId: "員工編號",
        label_login: "登錄",
        label_menu: "菜單",
        label_mobile: "員工電話號碼",
        label_name: "員工姓名",
        label_partname: "部門名稱",
        label_password: "密碼",
        label_remark: "備註",
        label_repeat_password: "重複密碼",
        label_role: "用戶角色",
        label_roleName: "角色名稱",
        label_warn: "警告",
        ph_depart: "部門",
        ph_role: "角色",
        ph_userName: "用戶名",
        require_doublepassword: "重新輸入密碼",
        require_employeename: "輸入員工姓名",
        require_employeenumber: "輸入員工編號",
        require_nomatch_password: "密碼不匹配",
        require_password: "輸入密碼",
        require_select_role: "輸入用戶角色",
        require_username: "輸入用戶名",
        th_authType: "角色類型",
        th_createTime: "創建時間",
        th_depart: "部門",
        th_email: "郵箱",
        th_mobile: "手機號碼",
        th_nums: "用戶總數",
        th_oparate: "操作",
        th_partname: "部門名稱",
        th_remark: "備註",
        th_roleName: "角色名稱",
        th_sharp: "",
        th_status: "狀態",
        th_userName: "用戶名"
    },
    Unavailable: "不可用",
    UpdateAgent: "修改代理",
    UpdateArticle: "更新文章",
    UpdateBanner: "更新橫幅",
    content: "內容",
    user: "用户",
    Userapplication: "用戶申請",
    USERID: "用戶ID",
    VALID: "有效",
    VALIDDATE: "有效日期",
    VALIDTY: "有效期",
    VAT: "增值稅",
    VIEWPNR: "查看PNR",
    VIEWSCHEDULE: "查看時間表",
    warehouse: {
        channel: {
            ph_search_channelwhs: "請輸入渠道倉庫的名稱",
            th_channel: "銷售渠道",
            th_checkin: "待入庫",
            th_freezed: "凍結庫存",
            th_mark: "備註",
            th_name: "渠道位置",
            th_number: "",
            th_realwhs: "所屬實體倉庫",
            th_skuRatio: "庫存SKU/總SKU",
            th_sold: "歷史銷售量"
        },
        enum_disable: "禁用",
        enum_normal: "正常",
        input_cancel: "取消",
        input_create: "創建",
        label_cancelTime: "取消",
        label_mark: "備註",
        ph_datePicker_end: "結束日期",
        ph_datePicker_range: "至",
        ph_datePicker_start: "開始日期",
        real: {
            ph_search_realwhs: "請輸入實體倉庫的名稱",
            th_address: "倉庫地址",
            th_channelRef: "渠道位置",
            th_checkin: "待入庫",
            th_contact: "倉庫聯繫人",
            th_freezed: "凍結庫存",
            th_name: "實體倉庫",
            th_number: "",
            th_skuRatio: "庫存SKU/總SKU",
            th_sold: "歷史銷售量"
        },
        td_del: "刪除",
        td_edit: "編輯",
        th_oper: "操作",
        th_state: "狀態",
        warn_noSel: "請先選擇一項"
    },
    Yes: "是",
	Agentcode: "代理商編碼",
	Agentlist: "代理商列表",
	Reductions:"轉帳",
	Transferin:"轉入",
	Transferout:"轉出",
	operate:"操作",
	Resendticket: "重新发送电子机票",
	travelTax: "旅游费",
	webFee: "订单服务费",
	Abandoned:"废票",
	Auditing:"审核",
	flightawaiting: "删除航段成功，待审核",
	flightFailed: "删除航段失败",
	pnrawaiting: "删除PNR成功，待审核",
	pnrdeletion: "PNR删除失败",
	Invalidticketfailed: "废票失败",
	Pendingpayment: "待支付",
	Flowtype: "流水类型",
	Businesstype: "业务类型",
	Uploadfiles: "上传文件",
	CancelTime: "取消时间",
	agent: "代理商",
	subagent: "子代理",
	RETURN:'返回',
	ADDCITY:'新增航线',
	MULTICITY:"多城市",
	ReturningRouteInfo:"返回路线信息",
	PriceInfo:"价格信息",
	NEXT:"下一步",
	TYPE:"类型",
	SPECIALASSISTANCEREQUIRED:"特殊援助类型",
	areaCode:"国家代码",
	SSRS:'SSRS',
	PRICE:"价格",
	Pleaseselectrefund:"请选择退票航段",
	Pleaseprovidecomplete:"请填写完整",
	Orderexceedslimit:'訂單超出限額',
	NonRefundable:'不可退款',
	Expiredthevalidityperiod:'有效期已過',
	seatNum:'座位數量',
	Pleaseselect:'請選擇',
	Pleasereschedulingdate:'請選擇改簽日期',
	Pleaserescheduleflightsegment:'請選擇改簽航段',
	Cannotbechanged:'不可改签',
	Areyousuretodelete:'确定删除?',
	cannotrefunded:'此班機不可退款',
	operator:'操作人',
	Pleaseenteryouremailaddress:'請輸入郵箱',
	refreport:'退改報表',
	salreport:'銷售報表',
	uplreport:'承運報表',
	Actualtakeoffstarttime:'實際起飛開始時間',
	Actualtakeoffendtime:'實際起飛結束時間',
	Doistarttime:'Doi開始時間',
	Doiendtime:'Doi結束時間',
	Plannedarrivalendtime:'計畫到達結束時間',
	Pleaseselectstartandenddates:'請選擇開始和結束日期',
	PleaseselectDoitakeofftime:'請選擇Doi開始結束時間或起飛開始結束時間',
	noshowreport:'弃乘報表',
	UndefinedReport:'特殊報表',
	imageuploadTypeTip:'只能上傳圖片',
	imageuploadSizeTip:'圖片大小不能超過2MB',
    // 本地化函数
    _f: {
        localPrice: (price: number) => {
            if (typeof price !== 'number') {
                return '';
            }

            let minus = price < 0;
            let price100x = Math.abs(Math.floor(price * 100 + 0.5));

            const floatPart = price100x % 100
            price100x = Math.floor(price100x / 100);

            const intPart: string[] = [];

            while (price100x > 999) {
                intPart.unshift((price100x % 1000).toString().padStart(3, '0'));
                price100x = Math.floor(price100x / 1000);
            };

            intPart.unshift(price100x.toString());
            return `${minus ? '-' : ''}${intPart.join(',')}.${floatPart.toString().padStart(2, '0')}`;
        },
        timeYMD: (y: number, mn: number, d: number) => {
            const formatNumber = dlc._f.formatNumber;
            return `${y}-${formatNumber(mn)}-${formatNumber(d)}`;
        },
        timeHM: (h: number, m: number) => {
            const formatNumber = dlc._f.formatNumber;
            return `${formatNumber(h)}:${formatNumber(m)}`;
        },
        formatDate: (date: Date) => {
            const formatNumber = dlc._f.formatNumber;
            const y = date.getFullYear();
            const mn = formatNumber(date.getMonth() + 1);
            const d = formatNumber(date.getDate());
            const h = formatNumber(date.getHours());
            const m = formatNumber(date.getMinutes());
            const s = formatNumber(date.getSeconds());

            return `${y}-${mn}-${d} ${h}:${m}:${s}`;
        },
        formatNumber: (n: number) => {
            return n.toString().padStart(2, '0')
        }
    }
}

type LangPack = typeof dlc;

export type I18nBase = Exclude<PickKeyOfObject<LangPack>, 'global' | '_f'>
export type I18nExtend<T extends keyof LangPack> = PickKeyOfObject<LangPack[T]>

export type LangNsp = PickObjectRecursive<typeof dlc>

export default { dlc };